/*
 * File: d:\projects\AutoFiFront\src\Theme\Component\RentingToolStyled.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday April 6th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday April 6th 2023 2:11:13 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styled from "styled-components";

const RentingToolStyled = styled.div.attrs(props => ({
    border: props.border,
    bgColor: props.bgColor,
}))`
border: solid 1px ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
border: ${props => props.border};
.title{
    margin: auto;
    text-decoration: underline ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first}!important;
}
.css-cca53m-JoySlider-root,
.css-cca53m-JoySlider-root:hover{
    padding: 0 !important;
    --Slider-trackBackground: ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first}!important;
}
`;

export default RentingToolStyled;
